'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Card } from '@/ui/cards/card/Card'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

export function CartSummaryPricingSkeleton({ children }: { children?: React.ReactElement }) {
  const { t } = useTranslation(['salesSummaryCard'])

  return (
    <Card skin="body" padding="lg" radius="sm" className="flex w-full flex-col gap-2 p-0">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <span className="flex justify-between text-lg">
            {t('salesSummaryCard:shippingFee')}
            <TextSkeleton size="2xl" leading="normal" className="w-12" />
          </span>
          <span className="flex justify-between text-2xl font-bold text-brand-1-800">
            {t('salesSummaryCard:totalExcludingTax')}
            <TextSkeleton size="lg" leading="normal" className="w-7" />
          </span>
        </div>
      </div>
      {children}
    </Card>
  )
}
